import React, { Component } from 'react';

import Select from 'react-select';
import Dialog from '../../../commonModules/interface/Dialog';
import PopUp from '../../../commonModules/interface/PopUp';
import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
import { Alert, AlertTitle } from '@material-ui/lab';
import { List, ListItem } from '@material-ui/core';


class FormNewUser extends Component {
    state = { 
        
    }
    render() {
        return (
            <PopUp 
                title="Ajouter un Nouvel Utilisateur"
                block={true}
                close={this.props.handleClose}
                submitAction={this.props.handleSubmit}
                // submitTitle="Créer un Utilisateur"
                maxWidth="sm"
            >

                <InputText 
                    label="Nom" 
                    type="text" 
                    id="userName" 
                    onChange={this.props.handleChange} 
                    value={this.props.userName} 
                    name="userName" 
                    error={this.props.errors.userName} 
                />
                
                <InputText 
                    type="text" 
                    id="email" 
                    label="Email" 
                    onChange={this.props.handleChange} 
                    value={this.props.email} 
                    name="email" 
                    error={this.props.errors.email} 
                />
                    
                <InputText 
                    label="Mot de Passe" 
                    placeholder="Choisissez un mot de passe unique" 
                    type="password" 
                    id="userPassword" 
                    onChange={this.props.handleChange} 
                    value={this.props.userPassword} 
                    name="userPassword" 
                    error={this.props.errors.userPassword} 
                />

                <InputText 
                    label="Confirmer le Mot de Passe" 
                    placeholder="Choisissez un mot de passe unique" 
                    type="password" 
                    id="confirmMDP" 
                    onChange={this.props.handleChange} 
                    value={this.props.confirmMDP} 
                    name="confirmMDP" 
                    error={this.props.errors.confirmMDP} 
                />
                    
                <InputSelect
                    label="Role"
                    options={this.props.roleList}
                    value={this.props.role}
                    placeholder="Choisissez un Role"
                    onChange={(option) => this.props.handleSelect(option, "role")}
                    error={this.props.errors.role}
                />
                    
                    
                    {this.props.role &&
                        // <p>
                        //     <i>Cet utilisateur aura accès aux Pages suivantes :...</i>
                        // {/* UPDATE TO LIST */}
                        //     <ul className="list-group">
                        //         {
                        //             this.props.roleDisplay.access.map( page => (
                        //                 <li className="list-group-item">{page}</li>
                        //             ))
                        //         }
                        //     </ul>
                        // </p>
                        <Alert severity="info">
                            <AlertTitle>Cet utilisateur aura accès aux Pages suivantes :</AlertTitle>
                        
                            <List className="list-group">
                                { this.props.roleDisplay.access.map( page => (
                                        <ListItem>{page}</ListItem>
                                    ))
                                }
                            </List>
                        </Alert>
                    }
            </PopUp>
        );
    }
}

export default FormNewUser;


{/* <div className="row m-5">
    <div className={"form-group col-sm-12 "+(this.props.errors.userName ? "has-error" : "")}>
        <div className="fg-line ">
        <label className="control-label">Nom</label>
            <input type="text" id="userName" className="form-control input-sm" onChange={this.props.handleChange} value={this.props.userName} name="userName" />
            <small className="help-block">{this.props.errors.userName}</small>
        </div>
    </div>
    <div className={"form-group col-sm-12 "+(this.props.errors.email ? "has-error" : "")}>
        <div className="fg-line ">
        <label className="control-label">Email</label>
            <input type="text" id="email" className="form-control input-sm" onChange={this.props.handleChange} value={this.props.email} name="email" />
            <small className="help-block">{this.props.errors.email}</small>
        </div>
    </div>
    <div className={"form-group col-sm-12 "+(this.props.errors.userPassword ? "has-error" : "")}>
        <div className="fg-line ">
        <label className="control-label">Mot de Passe</label>
            <input placeholder="Choisissez un mot de passe unique" type="password" id="userPassword" className="form-control input-sm" onChange={this.props.handleChange} value={this.props.userPassword} name="userPassword" />
            <small className="help-block">{this.props.errors.userPassword}</small>
        </div>
    </div>
    <div className={"form-group col-sm-12 "+(this.props.errors.confirmMDP ? "has-error" : "")}>
        <div className="fg-line ">
        <label className="control-label">Confirmer le Mot de Passe</label>
            <input type="password" id="confirmMDP" className="form-control input-sm" onChange={this.props.handleChange} value={this.props.confirmMDP} name="confirmMDP" />
            <small className="help-block">{this.props.errors.confirmMDP}</small>
        </div>
    </div>
    <div className={"form-group col-sm-12 "+(this.props.errors.role ? "has-error" : "")}>
        <label className="control-label">Role</label> 
        <Select
            options={this.props.roleList}
            className="form-control"
            value={this.props.roleDisplay}
            placeholder="Choisissez un Role"
            onChange={(option) => this.props.handleSelect(option, "role")}
            style={{border: '0'}}
            // selectedValue={this.props.role}
        />
        <small className="help-block">{this.props.errors.role}</small>
    </div>
    {this.props.role &&
        <p>
            <i>Cet utilisateur aura accès aux Pages suivantes :...</i>
        
            <ul className="list-group">
                {
                    this.props.roleDisplay.access.map((page)=>(
                        <li className="list-group-item">{page}</li>
                    ))
                }
            </ul>
        </p>
    }
</div> */}